// extracted by mini-css-extract-plugin
module.exports = {"deleteAction":"OptionList_deleteAction__Q7J4Z","addOptionContainer":"OptionList_addOptionContainer__1p2Xx","dashes":"OptionList_dashes__RGQGY","option":"OptionList_option__3wF_o"};